import {
  apiGet,
  apiPut,
  apiDelete,
  apiPost,
} from '../ApiService';

export default {
  getApiName() {
    return 'addresses';
  },

  getItems(p = 1, params) {
    return apiGet(`/addresses?page=${p}`, { params })
      .then(response => ({
        data: response.data.docs.map(item => ({
          ...item,
          id: item._id,
          name: item.title,
        })),
        records: response.data.pages.allRecords,
      }))
      .catch((error) => {
        throw new Error(error.response.data.error.message);
      });
  },

  getById(id) {
    return apiGet(`/addresses/${id}`)
      .then((response) => {
        const result = {
          id: response.data._id,
          name: response.data.name,
          relations: [],
          inputs: [],
          checkboxes: [],
        };

        return result;
      })
      .catch((error) => {
        throw new Error(error.response.data.error.message);
      });
  },

  removeLinkedItem() {
    return null;
  },

  addLinkedItem() {
    return null;
  },

  deleteItem(id) {
    return apiDelete(`/addresses/${id}`)
      .then(response => response)
      .catch((error) => {
        throw new Error(error.response.data.error.message);
      });
  },

  getFields() {
    return {
      relations: [],
      inputs: [
        {
          title: 'Адрес',
          name: 'createaddress',
          value: '',
        },
      ],
      checkboxes: [],
    };
  },

  updateItem(id, body) {
    console.log('body', body);
    return apiPut(`/addresses/${id}`, body)
      .then(response => response)
      .catch((error) => {
        throw new Error(error.response.data.error.message);
      });
  },

  createItem(body) {
    return apiPost('/addresses', body)
      .then(response => response)
      .catch((error) => {
        throw new Error(error.response.data.error.message);
      });
  },

  searchItem(body) {
    return apiGet(`/addresses?search=${body.search}`)
      .then(response => response.data.docs.map(item => ({
        id: item._id,
        name: item.title,
        ...item,
      })))
      .catch(error => console.log('Not Search', error));
  },
};
